import React from "react";
import { useOutletContext } from "react-router-dom";
import { PostReviewView } from "@/domains/Client/components/PostReviewView";
import type { Post } from "@/core/types/postTypes";

interface ApprovalOutletContext {
  clientId: string;
  token?: string;
  pendingPosts: Post[];
  onReviewPost: (postId: string, isReviewed: boolean) => Promise<void>;
  onUpdate: (postId: string, updates: { caption?: string; status?: string }) => Promise<void>;
}

export const PostReviewRoute: React.FC = () => {
  const { clientId, token, pendingPosts, onReviewPost, onUpdate } =
    useOutletContext<ApprovalOutletContext>();

  return (
    <PostReviewView
      clientId={clientId}
      token={token}
      pendingPosts={pendingPosts}
      onReviewPost={onReviewPost}
      onUpdate={onUpdate}
    />
  );
};
